(() => {
  'use strict';

  if (window.ITSBasicSalesRepTransfer) return;

  const endpoint = '/apps/bayi-basvuru/representative-transfer';
  const i18n = window.ITSBasicI18n?.cart || {};
  const text = (key) => i18n[key] || '';

  function formatMoney(cents, currency) {
    const amount = Number(cents || 0) / 100;
    const locale = document.documentElement.lang || 'tr-TR';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency || 'TRY',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    } catch (error) {
      return `${amount.toFixed(2)} ${currency || 'TRY'}`;
    }
  }

  function cleanVariantTitle(value) {
    const title = String(value || '').trim();
    if (!title || title.toLowerCase() === 'default title') return '';
    return title;
  }

  function getVariantUrl(item) {
    const fallbackHandle = item.handle || item.product_handle || '';
    const localizedRoot = window.Shopify?.routes?.root || '/';
    const fallbackPath = fallbackHandle
      ? `${localizedRoot}products/${fallbackHandle}`
      : `${localizedRoot}collections/all`;
    let url;

    try {
      url = new URL(item.url || fallbackPath, window.location.origin);
    } catch (error) {
      url = new URL(fallbackPath, window.location.origin);
    }

    if (item.variant_id) {
      url.searchParams.set('variant', String(item.variant_id));
    }

    return url.href;
  }

  function buildMessage(cart) {
    const currency = cart.currency || 'TRY';
    const lines = [
      text('hello'),
      '',
      text('intro'),
      '',
      text('summary'),
      '',
    ];

    cart.items.forEach((item, index) => {
      const productTitle = String(item.product_title || item.title || text('fallbackProduct')).trim();
      const variantTitle = cleanVariantTitle(item.variant_title);

      lines.push(`*${index + 1}. ${productTitle}*`);
      if (variantTitle) lines.push(`${text('variant')}: ${variantTitle}`);
      lines.push(`${text('packageQuantity')}: ${Number(item.quantity || 0)}`);
      lines.push(`${text('lineTotal')}: ${formatMoney(item.final_line_price, currency)}`);
      lines.push(`${text('productLink')}: ${getVariantUrl(item)}`);

      if (index < cart.items.length - 1) lines.push('');
    });

    lines.push(
      '',
      '────────────',
      `${text('totalPackages')}: ${Number(cart.item_count || 0)}`,
      `${text('cartTotal')}: *${formatMoney(cart.total_price, currency)}*`,
      '',
      text('closing')
    );

    return lines.join('\n');
  }

  function applyMessageToWhatsAppUrl(rawUrl, message) {
    if (!rawUrl) throw new Error(text('whatsappMissing'));

    try {
      const url = new URL(rawUrl, window.location.origin);
      url.searchParams.set('text', message);
      return url.toString();
    } catch (error) {
      const encodedMessage = encodeURIComponent(message);
      const withoutText = String(rawUrl)
        .replace(/([?&])text=[^&]*/i, '$1')
        .replace(/[?&]$/, '');
      const separator = withoutText.includes('?') ? '&' : '?';
      return `${withoutText}${separator}text=${encodedMessage}`;
    }
  }

  async function open(options = {}) {
    const source = options.source || 'cart';
    const popup = window.open('', '_blank');

    try {
      const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });

      if (!cartResponse.ok) throw new Error(text('cartFetchError'));

      const cart = await cartResponse.json();
      if (!Array.isArray(cart.items) || cart.items.length === 0) {
        throw new Error(text('empty'));
      }

      const items = cart.items.map((item) => ({
        title: item.product_title || item.title,
        variantTitle: cleanVariantTitle(item.variant_title),
        quantity: item.quantity,
        finalLinePrice: item.final_line_price,
        variantId: item.variant_id,
        url: getVariantUrl(item),
      }));

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          source,
          pageUrl: window.location.href,
          cart: {
            itemCount: cart.item_count,
            totalPrice: cart.total_price,
            currency: cart.currency || 'TRY',
            items,
          },
        }),
      });

      const data = await response.json().catch(() => ({}));
      if (!response.ok || !data.ok || !data.whatsappUrl) {
        throw new Error(data.message || text('repMissing'));
      }

      const whatsappUrl = applyMessageToWhatsAppUrl(data.whatsappUrl, buildMessage(cart));

      if (popup && !popup.closed) {
        popup.location.href = whatsappUrl;
      } else {
        window.location.href = whatsappUrl;
      }
    } catch (error) {
      if (popup && !popup.closed) popup.close();
      throw error;
    }
  }

  window.ITSBasicSalesRepTransfer = Object.freeze({
    open,
    buildMessage,
  });
})();
